import { Form, Formik } from "formik";
import React, { useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { PropagateLoader } from "react-spinners";
import Button from "../../../../atoms/Button";
import InputField from "../../../../atoms/InputField";
import { UPDATE_DEBIT_REGISTER } from "../../../../../api/apiEmpresas";

const ModalEditEdoCta = ({ refetch, onClose, cuenta }) => {
    const [loading, setLoading] = useState(false);

    const initialValues = {
        month: cuenta.month || "",
        payment_concept: cuenta.payment_concept || "",
        num_factura: cuenta.num_factura || "",
        comment: cuenta.comment || "",
        total : cuenta.total || 0,
    };

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            await UPDATE_DEBIT_REGISTER(cuenta.id ,values);
            refetch();
            onClose();
            toast.success("Registro exitoso");
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setLoading(false);
        }
    };

    const validate = (values) => {
        const errors = {};
        if (!values.month) errors.month = "La fecha es requerida";
        if (!values.payment_concept) errors.payment_concept = "El concepto de pago es requerido";
        if (!values.num_factura) errors.num_factura = "El numero de factura es requerido";
        if (values.total === null || values.total === undefined || values.total < 0) {
            errors.total = values.total < 0 ? "El monto no puede ser negativo" : "El monto es requerido";
        }
        return errors;
    };

    const servicesValues = [
        { label: "Asesoria contable", value: "Asesoria_contable" },
        { label: "Renta de sistema contable", value: "Renta_de_sistema_contable" },
        { label: "Supervisión contable de operaciones", value: "Supervision_contable_de_operaciones" },
        { label: "Auditoria fiscal", value: "Auditoria_fiscal" },
        { label: "Administración de buzón tributario", value: "Administracion_de_buzon_tributario" },
        { label: "Otros", value: "Otros" },
    ];

    return (
        <div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate}>
                {({ values, setFieldValue }) => (
                    <Form className="w-full flex flex-col items-center">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div className="w-full">
                                <label className="block text-base font-bold text-black">Concepto de pago</label>
                                <Select
                                    name="payment_concept"
                                    options={servicesValues}
                                    className="basic-multi-select border border-black rounded-lg"
                                    classNamePrefix="select"
                                    onChange={(option) => setFieldValue("payment_concept", option?.label || "")}
                                    value={servicesValues.find(opt => opt.label === values.payment_concept) || null}
                            />
                            </div>
                            <InputField name="month" label="Fecha de pago" type="date" />
                            <InputField name="num_factura" label="Numero de factura" type="number" />
                            <InputField name="comment" label="Comentario" />
                            <InputField name="total" label="Cantidad pagada" type="number" />
                        </div>
                        <Button
                            text={loading ? <PropagateLoader color="red" /> : "Registrar"}
                            type="submit"
                            disabled={loading}
                            bgColor="blue"
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ModalEditEdoCta;